import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=7084566e&scoped=true&"
import script from "./ItemForm.vue?vue&type=script&lang=js&"
export * from "./ItemForm.vue?vue&type=script&lang=js&"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=7084566e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084566e",
  null
  
)

export default component.exports